var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-project-block container my-3" }, [
    _c("h5", { staticClass: "create-project-header" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$resourceString[
              "myProject.Project.EditPage.Item.ColorPreviewModal.Title"
            ]
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "wf-modal-button-close btn button-full",
        attrs: { type: "button" },
        on: {
          click: function() {
            _vm.hideModal("colors-preview")
          }
        }
      },
      [
        _c("span", {
          staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
          attrs: { "aria-label": "Close modal" }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _vm.getFilteredRecord && _vm.getFilteredRecord.length > 0
        ? _c("div", {}, [
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "color-preview-slide" },
                [
                  _vm.selectedColor && _vm.selectedColor.colorNumber
                    ? _c(
                        "VueSlickCarousel",
                        _vm._b(
                          {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "nextArrow",
                                  fn: function() {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "custom-arrow-next",
                                          attrs: { type: "button" }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "png-icon png-icon-icons-glyph--ko-chevron-right"
                                          })
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                },
                                {
                                  key: "prevArrow",
                                  fn: function() {
                                    return [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "custom-arrow-prev",
                                          attrs: { type: "button" }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "png-icon png-icon-icons-glyph--ko-chevron-left"
                                          })
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3332624018
                            )
                          },
                          "VueSlickCarousel",
                          _vm.settings,
                          false
                        ),
                        [
                          _vm._v(" "),
                          _vm._v(" "),
                          _vm.selectedColor
                            ? _c(
                                "div",
                                { key: _vm.selectedColor.colorNumber },
                                [
                                  _c("img", {
                                    staticClass: "preview-img-fluid",
                                    attrs: {
                                      src: _vm.selectedColor.imageLink
                                        ? _vm.selectedColor.imageLink
                                        : _vm.selectedColor.imagePath,
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("my-project-color-preview-description", {
                                    attrs: { color: _vm.selectedColor },
                                    on: {
                                      addItemToCart: function($event) {
                                        return _vm.addItemToCart($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.getFilteredRecord, function(color, index) {
                            return _vm.selectedColor &&
                              color.colorNumber !==
                                _vm.selectedColor.colorNumber
                              ? _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("img", {
                                      staticClass: "preview-img-fluid",
                                      attrs: {
                                        src: color.imageLink
                                          ? color.imageLink
                                          : color.imagePath,
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("my-project-color-preview-description", {
                                      attrs: { color: color },
                                      on: {
                                        addItemToCart: function($event) {
                                          return _vm.addItemToCart($event)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }